import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import React, { useRef } from "react";
import { graphql, useFragment } from "react-relay";
import { useTranslation } from "@i18n/hooks";
import { DownloadUsageCsvButton_SearchDiscountUsageResultFragment$key } from "@relay/DownloadUsageCsvButton_SearchDiscountUsageResultFragment.graphql";

const SEARCH_DISCOUNT_USAGE_RESULT_FRAGMENT = graphql`
	fragment DownloadUsageCsvButton_SearchDiscountUsageResultFragment on SearchDiscountCodeUsagesResult {
		csv
	}
`;

type OwnProps = {
	searchDiscountUsageResultFragmentRef: DownloadUsageCsvButton_SearchDiscountUsageResultFragment$key;
};

export const DownloadUsageCsvButton = ({ searchDiscountUsageResultFragmentRef }: OwnProps) => {
	const { t } = useTranslation("common");
	const searchDiscountUsageResult =
		useFragment<DownloadUsageCsvButton_SearchDiscountUsageResultFragment$key>(
			SEARCH_DISCOUNT_USAGE_RESULT_FRAGMENT,
			searchDiscountUsageResultFragmentRef,
		);
	const toast = useRef<any>(null);
	const downloadCsv = () => {
		if (searchDiscountUsageResult.csv) {
			const link = document.createElement("a");
			link.href = "data:text/csv;charset=utf-8," + searchDiscountUsageResult.csv;
			link.download = "Verwendungen.csv";
			link.click();
		} else {
			toast.current?.show({
				severity: "success",
				life: 3000,
				summary: t("csv.csvCreated"),
				detail: t("csv.csvCreatedSuccessfully"),
			});
		}
	};

	return (
		<>
			<Toast ref={toast} />
			<Button label="CSV" icon="pi pi-download" className="h-3rem" onClick={downloadCsv} />
		</>
	);
};
